import { useState } from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../Navbar/logo.png";
import { LoginService } from "../../services";

// async function getHash(buffer, algo = "SHA-256") {
//   return crypto.subtle.digest(algo, buffer)
//     .then(hash => {
//       // here hash is an arrayBuffer, so we'll convert it to its hex version
//       let result = '';
//       const view = new DataView(hash);
//       for (let i = 0; i < hash.byteLength; i += 4) {
//         result += ('00000000' + view.getUint32(i).toString(16)).slice(-8);
//       }
//       return result;
//     });
// }

export default function Login() {
  const [password, setPassword] = useState();
  const [username, setUserName] = useState();
  const [message, setMessage] = useState("");
  const redirect = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = await LoginService.login(username, password);
    if (user.LoginName !== null) {
      setMessage("Welcome!");
      const personelId = Number(user.personelid || user.personelId || 0);
      if (personelId === 1 || personelId === 2) {
        redirect("/work-receipt");
      } else {
        redirect("/patients");
      }
    } else {
      setMessage("Username or password is wrong.");
    }
  };
  return (
    <div>
      <div className="container">
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100vh" }}
        >
          <div className="col-md-6 float-end">
            <Form onSubmit={handleSubmit}>
              <div className="px-3">
                <div className="vstack">
                  <img
                    src={logo}
                    width="30%"
                    style={{ alignSelf: "center" }}
                    alt="Orthomagic Logo"
                  />
                  <h3 className="text-center">Doctor Portal Login</h3>
                </div>

                <Form.FloatingLabel
                  className="mb-3"
                  label="Username"
                  controlId="username"
                >
                  <Form.Control
                    type="text"
                    placeholder="Username"
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </Form.FloatingLabel>
                <Form.FloatingLabel
                  className="mb-3"
                  label="Password"
                  controlId="password"
                >
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.FloatingLabel>
                <Button className="w-100" variant="primary" type="submit">
                  Login
                </Button>
                <text className="text-center">
                  {" "}
                  New doctor? Please register from{" "}
                  <Link to="/register"> here </Link>.
                </text>
                <br />
                <text className="text-center">
                  {" "}
                  Forgot your password? Reset your password{" "}
                  <Link to="/forgotpassword"> here </Link>.
                </text>
                {message && (
                  <div className="my-3 text-center rounded py-2 bg-danger text-white">
                    {message}
                  </div>
                )}
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
